import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'
import { cancelPaymentLinkAct } from '../../../../../../redux/actions'

import './styles.scss'
import { Button } from 'components/Form'
import { apiPayment } from 'api'
import InfoHeaderPayment from '../../Common/InfoHeaderPayment'
import Nixi1Spinner from 'components/Nixi1Spinner'

const CancelLink = (props) => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [orderInfo, setOrderInfo] = useState({})
  const [orderError, setOrderError] = useState('')
  const cancelLinkAct = bindActionCreators(cancelPaymentLinkAct, props.dispatch)
  const {
    user,
    orderId,
    plugin: { /* userState, */ cancellingLink, errors },
  } = props

  const onCancelLink = () => {
    cancelLinkAct.cancelLink(user, orderId, props.plugin.userState)
    setDisabledButton(true)
  }

  useEffect(() => {
    getOrder()
    return () => {
      cancelLinkAct.resetPlugin(user.id)
    }
  }, [])

  const getOrder = async () => {
    try{
      const order = await apiPayment.getOrderId({ userId: user._id, orderId })
      setOrderInfo(order.data)

    } catch (error) {
      setOrderError(I18n.t('message_error_data_list_distribution'))
    }
  }

  return (
    <div>
      <InfoHeaderPayment amount={orderInfo.total || 0} date={orderInfo.date || ''} currency={orderInfo.currency} />

      <div className='container-cancel'>
        <div>
          <label>{I18n.t('dashboard_user-status-after-payment-link')}</label>
        </div>
        <div>
          {
            cancellingLink ? (
              <Nixi1Spinner height='30px' width='100%' />
            ) : (
              <div style={{ width:'70%' }}>
                <Button 
                  primary
                  className={'buttonCreateNewPaymentLink'}
                  onClick={onCancelLink}
                  disabled={Object.keys(errors).length <= 0 && disabledButton? true : false}
                >
                  <label>
                    {I18n.t('dashboard_cancel-payment-link')}
                  </label>
                </Button>
              </div>
            )
          }
        </div>
        {Object.keys(errors).length > 0 ? (
          <div className='container-error'>
            {Object.keys(errors).map((e) => (
              <span key={e} className='text-danger'>{I18n.t(`dashboard_errors_${errors[e]}`)}</span>
            ))}
          </div>
        ) : disabledButton &&! cancellingLink ? (
          <div className='container-error'>
            <span className='text-success'>{I18n.t('dashboard_payment_link_cancel')}</span>
          </div>
        ) : null}
        {orderError.length > 0 && <div className='container-error'>
          <span className='text-danger'>{orderError}</span>
        </div> }
      </div>
    </div>
  )
}

export default connect()(CancelLink)
